module.exports = __webpack_public_path__ + "static/media/designer.e73a54a0.png";